import authRules from '../authRules.js';

const sameResource = (user) => {
  const { sameResource } = user.securityLevels;
  if (sameResource >= authRules.sameResource.sameResource) {
      return true;
  } else {
      return false;
    }
  }


export default sameResource;